angular.module('clientDashboardApp').directive('popoverConfirm',($compile,$timeout) => {
 return {
   restrict: 'A',
   template: require('./popoverConfirm.html'),
   scope: {
     callback: '&popoverConfirm',
     doNotShow : '=',
     isOpen : '=popoverOpen',
     payload: '=',
     popoverConfig : '='
   },
   controller: ($scope) => {

     $scope.doNotShowChecked = false

     $scope.updateDoNotShow = () => {
       $scope.doNotShow = $scope.doNotShowChecked
     }

     $scope.onConfirm = () => {
        $scope.callback({item:$scope.payload})
       $scope.isOpen = false;
     }

     $scope.onCancel = () => {
       $scope.isOpen = false;
     }

     $scope.$watch('isOpen',(newVal,oldVal) => {
       if(newVal !== oldVal && newVal === true && $scope.doNotShow){
         $scope.isOpen = false;
         $scope.callback({item:$scope.payload})
       }
     })

   }
 }
})
